<template>
  <b-modal title="Relatório de Despesas de Equipe" v-model="show" size="xl">
    <div id="relatorioDeEquipe">
      <b-container fluid>
        <!-- :::::::::::::::::::::::::::: HEADER DO RELATORIO DE EQUIPE :::::::::::::::::::::::::::: -->
        <b-row class="mt-2">
          <b-col cols="2">
            <img class="m-2" :src="require('/static/images/logo_sgcq.png')" aria-label="Logomarca do SGCQ" width="160" />
          </b-col>
          <b-col cols="10">
            <h3>NEW ENERGY TECH EIRELI</h3>
            <h6>Serviços Técnicos de Consultória, Projeto, Fabricação, Inspeção de Equipamentos.</h6>
            <h6>BR 304 - Km 50,5 - Zona Rural</h6>
            <h6>Fone: (84) 9 9604-4935 / (84) 9 8740-0525</h6>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col cols="8">
            <b-form-group label="Descrição:" label-for="descricao" label-cols="2" class="m-1">
              <b-form-input id="descricao" v-model="equipe.descricao" />
            </b-form-group>
          </b-col>

          <b-col cols="4" class="m-0">
            <b-form-group label="Início:" label-for="inicio" label-cols="3" class="m-1">
              <b-form-datepicker
                id="inicio"
                v-model="periodo.inicio"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
              ></b-form-datepicker>
            </b-form-group>
          </b-col>

          <b-col cols="5">
            <b-form-group label="Lider:" label-for="lider" label-cols="3" class="m-1">
              <b-form-input id="lider" v-model="equipe.lider" />
            </b-form-group>
          </b-col>

          <b-col cols="3">
            <b-form-group label="Custo:" label-for="custo" label-cols="3" label-align="right">
              <b-form-input id="custo" v-model.lazy="equipe.custo" v-money="money"  class="mr-5"/>
            </b-form-group>
          </b-col>

          <b-col cols="4" class="m-0">
            <b-form-group label="Final:" label-for="final" label-cols="3" class="m-1">
              <b-form-datepicker
                id="final"
                v-model="periodo.final"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
              ></b-form-datepicker>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- :::::::::::::::::::::::::::: DESPESAS DA EQUIPE :::::::::::::::::::::::::::: -->
        <hr />
        <b-row class="mt-2">
          <b-col cols="12" class="text-center">
            <h4><strong>DESPESAS DA EQUIPE</strong></h4>
          </b-col>
        </b-row>

        <b-table bordered small head-variant="light" :items="getPeriodDespesas(periodo)" :fields="fields.despesaRelatorio">
          <template #cell(data)="data">
            <div>
              <p class="pt-0 pb-0">
                {{ moment(data.item.data).format("DD/MM/YYYY") }}
              </p>
            </div>
          </template>

          <template #cell(valor)="data">
            <div>
              <p>{{ formatter.format(data.item.valor) }}</p>
            </div>
          </template>
        </b-table>

        <b-row>
          <b-col offset="6" cols="6">
            <h5 class="text-right">
              <strong>Total: {{ formatter.format(getTotalDespesas) }}</strong>
            </h5>
          </b-col>
        </b-row>

        <!-- :::::::::::::::::::::::::::: RELATÓRIOS DIÁRIOS :::::::::::::::::::::::::::: -->
        <hr />
        <b-row class="mt-2">
          <b-col cols="12" class="text-center">
            <h4><strong>RELATÓRIO DIÁRIO DA EQUIPE</strong></h4>
          </b-col>
        </b-row>

        <b-table bordered small head-variant="light" :items="getPeriodDiarios(periodo)" :fields="fields.diarioRelatorio">
          <template #cell(data)="data">
            <div>
              <p class="pt-0 pb-0">
                {{ moment(data.item.data).format("DD/MM/YYYY") }}
              </p>
            </div>
          </template>
        </b-table>
      </b-container>
    </div>

    <template #modal-footer>
      <b-row class="pb-1">
        <b-col cols="4" class="p-0"> </b-col>
        <b-col cols="8" class="p-0"> </b-col>
      </b-row>

      <b-button variant="primary" v-print="'#relatorioDeEquipe'">Imprimir</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { VMoney } from "v-money";
import { useEquipeStore } from "@/stores/EquipeStore";
import TableFields from "@/tools/TableFields";
import Equipe from "@/models/Equipe";

export default {
  name: "ModalDeRelatorioDeEquipe",

  data() {
    return {
      show: false,
      fields: new TableFields(),
      equipe: new Equipe(0, "", "Nova Equipe", new Date(), 0.0),
      periodo: { inicio: new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000), final: new Date() },
      formatter: new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      }),
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
    };
  },

  directives: { money: VMoney },

  methods: {
    update() {
      this.equipeStore.LISTAR_DIARIOS(this.equipe.id);
      this.equipeStore.LISTAR_DESPESAS(this.equipe.id);
    },

    call(equipe) {
      this.show = !this.show;
      this.equipe = equipe;
      this.update();
    },
  },

  setup() {
    const store = useSgcqStore();
    const equipeStore = useEquipeStore();
    const { getPeriodDiarios } = storeToRefs(equipeStore);
    const { getPeriodDespesas } = storeToRefs(equipeStore);
    const { getTotalDespesas } = storeToRefs(equipeStore);

    return {
      store,
      equipeStore,
      getPeriodDiarios,
      getPeriodDespesas,
      getTotalDespesas,
    };
  },
};
</script>

<style lang="scss" scoped>
.emlinha {
  display: inline-flexbox;
}
.borda-redonda {
  border: 1px solid lightgray;
  border-radius: 3px;
  padding: 0.6rem;
}
</style>
